import { Modal, Switch } from '@lib/components'
import { FileXml } from '@lib/images'
import { Button, ThemeColors } from '@octopus-do/octopus-storybook'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { normalize } from '@/helpers'
import type { ModalProps } from '@/types/modal'
import css from './ExportAsXml.module.scss'
import { useControls, useSubmitExportAsXml } from './hooks'

const ExportAsXml: React.FC<ModalProps> = ({ onClose, onBack }) => {
  const projectName = useSelector(migrationProjectSelector.getProjectTitle)

  const { actions, state } = useControls()
  const { handleSubmit, size } = useSubmitExportAsXml(state)

  const handleClick = ({
    action,
    format,
  }: {
    action: Function
    format: string
  }) => {
    sendGtmEvent(GtmTriggerName.EXPORT_XML, 'Click on export as XML')

    action()
      .then((blob: any) => {
        const link = document.createElement('a')

        link.download = `${normalize(projectName)}.${format}`
        link.href = window.URL.createObjectURL(blob)
        link.click()
        window.URL.revokeObjectURL(link.href)
        onClose()
      })
      .catch((e: any) => {
        console.error(e)
      })
  }

  return (
    <Modal
      title="Export as XML"
      onClose={onClose}
      onBack={onBack}
      width={352}
      image={<FileXml />}
      classnames={{
        content: css.modalContent,
      }}
    >
      <div className={ThemeColors.light}>
        <div className={css.container}>
          <div className={css.item}>
            <span className={cx(css.title, css.disabled)}>Pages & Blocks</span>
            <Switch disabled checked />
          </div>

          <div className={css.item}>
            <span className={css.title}>Notes</span>
            <Switch checked={state.isNotes} onChange={actions.setNotes} />
          </div>

          <div className={css.item}>
            <span className={css.title}>SEO Meta Tags</span>
            <Switch
              checked={state.isSeoMetaTags}
              onChange={actions.setSeoMeta}
            />
          </div>
        </div>

        <div className={css.footer}>
          <Button
            label="Save"
            onClick={() => handleClick({ action: handleSubmit, format: 'xml' })}
          />
          <div className={css.size}>{size} lines XML file</div>
        </div>
      </div>
    </Modal>
  )
}

export default ExportAsXml
